import { useParams } from 'react-router';
import { useDatasetContext } from '../../../hooks/context/useDatasetContext';
import { useMemo } from 'react';
import { useSourceDatasetConditions } from './useSourceDatasetConditions';
import { Dataset } from '../../../types/types';

export const useResolvedFormDataset = (): Dataset | undefined => {
  const { displayReferenceDataset, displaySlaveDataset } =
    useSourceDatasetConditions();
  const { formId, datasetId, subsetId } = useParams<{
    formId: string;
    datasetId?: string;
    subsetId?: string;
  }>();
  const {
    dataset: contextDataset,
    slaveDatasets: contextSlaveDatasets,
    referenceDatasets: contextReferenceDatasets,
  } = useDatasetContext();

  const dataset: Dataset | undefined = useMemo(() => {
    if (displayReferenceDataset) {
      return contextReferenceDatasets[formId];
    }
    if (displaySlaveDataset) {
      return contextSlaveDatasets[subsetId ?? ''];
    }
    // Menu-launched form (/form/:formId/add) has no datasetId and thus no dataset
    // to fetch; the form definition is self-sufficient, so provide a minimal stub.
    if (!datasetId && formId) {
      return { datasetId: formId, apiMethod: '', label: '', items: [] };
    }
    return contextDataset;
  }, [
    contextSlaveDatasets,
    contextReferenceDatasets,
    contextDataset,
    formId,
    datasetId,
    subsetId,
    displayReferenceDataset,
    displaySlaveDataset,
  ]);

  return dataset;
};
